import * as React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

export default function EditProfileIcon(props: Props): JSX.Element {
  const { width = '1.125rem', height = '1.125rem', ...rest } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M5.77736 20.2223H7.2476L17.3329 10.137L15.8627 8.66674L5.77736 18.7521V20.2223ZM4.74561 22.2858C4.45329 22.2858 4.20825 22.1869 4.01049 21.9892C3.81274 21.7914 3.71387 21.5464 3.71387 21.254V18.7521C3.71387 18.4769 3.76545 18.2147 3.86863 17.9653C3.9718 17.716 4.11797 17.4968 4.30712 17.3076L17.3329 4.30761C17.5393 4.11846 17.7671 3.97229 18.0164 3.86912C18.2658 3.76594 18.528 3.71436 18.8032 3.71436C19.0783 3.71436 19.3448 3.76594 19.6028 3.86912C19.8607 3.97229 20.0842 4.12705 20.2734 4.3334L21.692 5.77785C21.8984 5.967 22.0489 6.19055 22.1434 6.44848C22.238 6.70642 22.2853 6.96436 22.2853 7.22229C22.2853 7.49742 22.238 7.75966 22.1434 8.009C22.0489 8.25834 21.8984 8.48618 21.692 8.69253L8.69204 21.6925C8.50289 21.8817 8.28364 22.0278 8.0343 22.131C7.78497 22.2342 7.52273 22.2858 7.2476 22.2858H4.74561ZM16.5849 9.41475L15.8627 8.66674L17.3329 10.137L16.5849 9.41475Z"
        fill="currentColor"
      />
    </svg>
  );
}


